import { ComponentType, ReactNode } from 'react';

import ErrorBoundary from './ErrorBoundary';

interface WithErrorBoundaryOptions {
  fallback?: ReactNode;
}

const withErrorBoundary = <P extends object>(
  WrappedComponent: ComponentType<P>,
  options?: WithErrorBoundaryOptions
) => {
  const ComponentWithBoundary = (props: P) => {
    return (
      <ErrorBoundary fallback={options?.fallback ?? <></>}>
        <WrappedComponent {...props} />
      </ErrorBoundary>
    );
  };

  ComponentWithBoundary.displayName = `WithErrorBoundary(${WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'})`;

  return ComponentWithBoundary;
};

export default withErrorBoundary;
